import { $_app_server } from '@/_helpers'

export const docService = {
    upload,
    changeChannel,
    deleteId,
    deleteAll,
    sendAll,
    send,
    resend,
    listToSign,
    setSigData,
    templates,
    uploadRfiles,
    readResponsePart, 
    readFile
}

function upload (formData) {
  return $_app_server.post('files', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
  })
  .then(response => response.data)
} 

function uploadRfiles (formData) {
  return $_app_server.post('rfiles', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
  .then(response => response.data)
} 



function changeChannel (id, channel) {
  return $_app_server.patch("sessiondocs/" + id + "/sendchannel", channel)
  .then(response => response.data)
}

function deleteId (id) {
  return $_app_server.delete("sessiondocs/" + id)
  .then(response => response.data)
}

function deleteAll (list) {
  return $_app_server.patch("sessiondocs/delete/", list)
  .then(response => response.data)
}

function send (id) {
  return  $_app_server.patch("sessiondocs/" + id + "/send/")
  .then(response => response.data)
}

function resend (id) {
  return  $_app_server.patch("sessiondocs/" + id + "/resend/")
  .then(response => response.data)
}

function sendAll (list) {
  return $_app_server.patch("sessiondocs/send/", list)
  .then(response => response.data)
}

function templates () {
  return  $_app_server.get("doctemplate")
  .then(response => response.data)
}

function listToSign () {
  return  $_app_server.get("sessiondocs")
  .then(response => response.data)
}

function readResponsePart (id) {
  return  $_app_server.get("file/response/part/"+id)
  .then(response => response.data)
}
 
function readFile (file) {
  return  $_app_server.get(file)
  .then(response => response.data)
}
  
function setSigData (id, sigData) {
  return  $_app_server.post("sessiondocs/" + id + "/sig", sigData)
  .then(response => response.data)
}
  

  